import { AuthenticationMethod, Platform } from 'src/app/models/api/common';

export function arePlatformActionsAllowed(platform: Platform, authMethod: AuthenticationMethod) {
  switch (platform) {
    case Platform.powerplatform:
    case Platform.salesforce:
    case Platform.chatGptEnterprise:
      return true;
    case Platform.amazonBedrock:
      return true;
    case Platform.budibase:
      return true;
    case Platform.airtable:
      return true;
    case Platform.workato:
      return authMethod == AuthenticationMethod.apikey || authMethod == AuthenticationMethod.apitoken;
    default:
      return false;
  }
}
